import React, { useState, useEffect } from 'react';
import { ListLayout } from '../../containers/Layout';
import { isEmpty } from 'lodash';
import Spin from '../../../../../commonModules/interface/Spin';
import { InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';
import { TableRow, TableCell, TableHead, TableBody, Box, IconButton } from '@material-ui/core';
import { DeleteRounded, AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import DeleteDialog from '../../../../../commonModules/interface/DeleteDialog';
import { toast } from 'react-toastify';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import { useSelector } from 'react-redux';

const ListTransferCommercials = (props) => {
    const [state, setState] = useState({
        filteredList: [],
        selectSearchDisplay: {},
        selectSearch: "",
        deletePopUp: false,
        toDelete: { id: "" },
    });
    const fetchTransfers = useFetchTransfers("commercial");
    const STATE = useSelector((state) => state.inventory.requestState); 
    const COMMERCIAL_REAS = useSelector((state) => state.inventory.commercialReas); 
    const SHOPS = useSelector((state) => state.inventory.shops); 
    const AGENTS = useSelector((state) => state.agents.agents); 

    useEffect(() => {
        console.log('MOUNTING ListTransferInstalls ');
        if(isEmpty(COMMERCIAL_REAS)) {
            fetchTransfers();
        }
    }, []);
    const createReapproList = () => {
        const { currentPage, rowsPerPage } = props;
        const { selectSearch } = state;
        let list = selectSearch ? commercialFilter(selectSearch) : Object.values(COMMERCIAL_REAS);

        return [
            list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((reappro) => {
                const commercial = AGENTS && AGENTS[reappro.commercial_id];
                const shop = SHOPS[reappro.shop_id] || {};

                return (
                    <TableRow key={reappro.id} hover>
                        <TableCell>{new Date(reappro.creation_date).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            <a href="#" onClick={() => props.handleSingleShop(shop)}>
                                {shop.name}
                            </a>
                        </TableCell>
                        <TableCell>
                            {commercial && (
                                <a href="#" onClick={() => props.handleSingleCom(commercial.id)}>
                                {commercial.name}
                                </a>
                            )}
                        </TableCell>
                        <TableCell>
                            <IconButton color="secondary" onClick={() => props.handleSingleComRea(reappro, shop, commercial)}>
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <IconButton onClick={() => setState({ toDelete: reappro, deletePopUp: true })}>
                                <DeleteRounded color="error" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            }),
            list.length,
        ];
  };

    const createCommercialList = () => {
        let list = [];
        let comID = [];

        if (AGENTS) {
            Object.values(COMMERCIAL_REAS).forEach((item) => {
                if (!comID.includes(item.commercial_id)) {
                comID.push(item.commercial_id);
                }
            });
            comID.forEach((agentID) => {
                let agent = AGENTS[agentID] || { id: agentID, name: "" };
                let selected = false;
                if (state.selectSearch === agent.id) {
                selected = true;
                }
                list.push({ value: agent.id, label: agent.name, disabled: selected });
            });
        }

        return list;
    };

    const commercialFilter = (selected) => {
        let filteredCommercial = Object.values(COMMERCIAL_REAS).filter((rea) => rea.commercial_id === selected);

        return filteredCommercial;
    };

    const deleteCommercialRea = async (password) => {
        console.log('[INFO] delete with password:', password ? 'provided' : 'not provided');
        
        // Wait for the Redux action to complete and get the result
        const result = await props.deleteCommercialRea(state.toDelete, password);

        // Check the result directly from the action instead of Redux state
        if (result && result.success) {
            toast.success("Reappro supprimé");
            setState({
                deletePopUp: false,
                toDelete: { id: "" },
            });
        } else {
            const errorMessage = result?.error || STATE.commercialReas.error || "Une erreur est survenue";
            console.error("[ERROR] delete commercial rea:", errorMessage);
            toast.error(errorMessage);
        }
    };

    let list = [[], 0];
    if (!isEmpty(COMMERCIAL_REAS)) {
        list = createReapproList();
    }

    return (
        <React.Fragment>
            <div>
                <Box p={1}>
                    <InputSelectMagasin
                        options={createCommercialList()}
                        value={state.selectSearchDisplay || { value: "", label: "" }}
                        label="Sélectionner un Commercial"
                        onChange={(option) => setState({ selectSearch: option.value, selectSearchDisplay: option })}
                    />
                </Box>
                {state.deletePopUp && (
                    <DeleteDialog
                        title={"le reappro n°" + state.toDelete.id}
                        handleSubmit={deleteCommercialRea}
                        close={() => setState({ deletePopUp: false })}
                        open={true}
                        disabled={STATE.commercialReas.fetching}
                    />
                )}

                <ListLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Shop</TableCell>
                            <TableCell>Commercial</TableCell>
                            <TableCell colSpan={2}>Détails</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list[0]}
                        {STATE.commercialReas.fetching && <Spin noOverlay />}
                        {isEmpty(COMMERCIAL_REAS) && STATE.commercialReas.fetched && (
                            <TableRow>
                                <TableCell colSpan="7">
                                <div className="text-center">
                                    <h5>Pas de Reapprovisionnement</h5>
                                    Cliquez sur <b className="onglet">"Nouveau"</b> Pour en créer un
                                </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {list[1] > 20 && (
                        <TableFooterPagination
                            colSpan={4}
                            items={list[0]}
                            count={list[1]}
                            onChangePage={props.onChangePage}
                            initialPage={props.currentPage || 0}
                        />
                    )}
                </ListLayout>
             </div>
        </React.Fragment>
    );
};

export default ListTransferCommercials;
